export const Copy = () => {
  return (
    <svg fill="none" viewBox="-1 -1 24 24" height="24" width="24">
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M15.354166666666666 4.125V1.6041666666666665c0 -0.5062566666666667 -0.41039166666666665 -0.9166666666666666 -0.9166666666666666 -0.9166666666666666h-12.833333333333332c-0.5062566666666667 0 -0.9166666666666666 0.4104008333333333 -0.9166666666666666 0.9166666666666666v12.833333333333332c0 0.506275 0.41041 0.9166666666666666 0.9166666666666666 0.9166666666666666H4.125"
        strokeWidth="2"
      ></path>
      <path
        stroke="currentColor"
        strokeLinejoin="round"
        d="M6.645833333333333 7.5625c0 -0.5062658333333333 0.41041 -0.9166666666666666 0.9166666666666666 -0.9166666666666666h12.833333333333332c0.506275 0 0.9166666666666666 0.41041 0.9166666666666666 0.9166666666666666v12.833333333333332c0 0.506275 -0.41039166666666665 0.9166666666666666 -0.9166666666666666 0.9166666666666666h-12.833333333333332c-0.5062658333333333 0 -0.9166666666666666 -0.41039166666666665 -0.9166666666666666 -0.9166666666666666v-12.833333333333332Z"
        strokeWidth="2"
      ></path>
    </svg>
  );
};
